"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stop = void 0;
var _react = _interopRequireDefault(require("react"));
var Stop = exports.Stop = function Stop() {
  return _react["default"].createElement("svg", {
    width: "11",
    height: "11",
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M9.875 0.25H1.625C0.992188 0.25 0.5 0.765625 0.5 1.375V9.625C0.5 10.2578 0.992188 10.75 1.625 10.75H9.875C10.4844 10.75 11 10.2578 11 9.625V1.375C11 0.765625 10.4844 0.25 9.875 0.25Z",
    fill: "white"
  }));
};